import firebase from 'firebase/compat/app';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { firebaseConfig } from 'src/config';
import 'firebase/compat/storage';

const firebaseTempProject = firebase.initializeApp(firebaseConfig);

export const firebaseProject = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseProject);
export const firestoredb = getFirestore(firebaseProject);
export const storage = firebaseTempProject.storage(
  `gs://${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`
);
